import React from 'react';

import { ButtonV2 } from '@zola/zola-ui';

import ZoomIcon from 'assets/images/virtualEvents/zoom_app_icon.svg';

import styles from './VirtualEventOnboardingModal.module.less';

const VirtualEventOnboardingModal = ({ onInitTour, closeModal }) => {
  const startTour = () => {
    onInitTour();
    closeModal();
  };

  const endTour = () => {
    closeModal();
  };

  return (
    <div className={styles.container}>
      <h1>Host Virtual Events on Your Site</h1>
      <h4>
        From your wedding shower to reception, celebrate with your loved ones right on your
        beautiful wedding website—all from the comfort of your homes.
      </h4>
      <div className={styles.stepsSection}>
        <h3>How to Make Magic Happen</h3>
        <div className={styles.stepContainer}>
          <div className={styles.step}>
            <img className={styles.stepImg} src={ZoomIcon} alt="zoom-icon" />
            <p className={styles.stepText}>1. Connect to Zoom</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepEmoji} role="img" aria-label="handshake-emoji">
              💻
            </span>
            <p className={styles.stepText}>2. Set Up Your Event</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepEmoji} role="img" aria-label="handshake-emoji">
              🕺🏾
            </span>
            <p className={styles.stepText}>3. Celebrate (Virtually)</p>
          </div>
        </div>
      </div>
      <div className={styles.btnContainer}>
        <ButtonV2 onClick={startTour}>Get Started</ButtonV2>
        <ButtonV2 onClick={endTour} className={styles.btnPadding} variant="secondary">
          Do This Later
        </ButtonV2>
      </div>
    </div>
  );
};

export default VirtualEventOnboardingModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/VirtualEventOnboardingModal/VirtualEventOnboardingModal.jsx